import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../api/hooks/useColors";

export const ScreenshotAccordion = ({
  images,
  onExpanded,
  title = "View screenshot",
}) => {
  const colors = useColors();
  const [expanded, setExpanded] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (onExpanded) onExpanded(setExpanded);
  }, []);

  const handleImageClick = (image) => {
    setSelectedImage(image.file);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded((prev) => !prev)}
        sx={{ backgroundColor: `${colors.sidebar_bg}`, width: "700px" }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle2" color={colors.primary_darker}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {images.map((image) => {
            return (
              <div>
                {image.note ? (
                  <div>
                    <i>
                      <Typography variant="h5">{image.note}</Typography>
                      <br />
                    </i>
                  </div>
                ) : (
                  <div />
                )}
                <center>
                  <img
                    src={image.file}
                    alt={image.altext}
                    style={{ width: "600px", height: "auto" }}
                    onClick={() => handleImageClick(image)}
                  />
                </center>
              </div>
            );
          })}
        </AccordionDetails>
      </Accordion>
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth={true}>
        <img
          src={selectedImage}
          alt="Selected"
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "1200px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
      </Dialog>
    </div>
  );
};
